import { render, staticRenderFns } from "./Pic.vue?vue&type=template&id=6722c7c4&scoped=true"
import script from "./Pic.vue?vue&type=script&lang=js"
export * from "./Pic.vue?vue&type=script&lang=js"
import style0 from "./Pic.vue?vue&type=style&index=0&id=6722c7c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6722c7c4",
  null
  
)

export default component.exports